import React, { ReactNode, useContext, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import closeModalIcon from '../../assets/closeModal.svg'
import classNames from 'classnames'
import Avatar from 'components/avatar'
import ImageUserUpdate from 'containers/SettingProfileContainer/imageUserUpdate'
import { updateBeneficiary } from 'requests/benificary'
import UserContext from 'contexts/UserContext'
import { useFormik } from 'formik'
import * as yup from 'yup'
import UpdateInfo from 'containers/SettingProfileContainer/updateInfo'
import { LISTBANCAIRE } from 'components/listCartebancairepays'
import InputSelectComponent from 'components/inputSelectComponent'

type Beneficiary = {
  bankCode?: string
  bankName?: string
  identifiantCardNumber?: string
  confirmerNumeroCompte?: string
  accountNumber?: string
  personalInfo: {
    gender: string
    firstName: string
    lastName: string
    phone: {
      prefix: string
      number: string
    }
  }
  relationship: string
  language: string
  avatar: number
  userId: string
  _id: string
}

type RibLength =
  | number
  | {
      min: number
      max: number
    }
type typeListebank = {
  index: number
  code: string
  name: string
  swift: string
}
interface Props {
  isOpen: boolean
  children?: ReactNode
  closeModal: () => void
  benefUpdate: Beneficiary | undefined
  setBenefUpdate: React.Dispatch<React.SetStateAction<Beneficiary | undefined>>
  setBeneficiaryData: React.Dispatch<React.SetStateAction<Beneficiary[]>>
}

const UpdateModalBeneficiary = ({ isOpen, children, closeModal, setBeneficiaryData, benefUpdate }: Props) => {
  const { user } = useContext(UserContext)
  const [lengthCIN, setLenghtCIN] = useState(0)
  const [lengthRIB, setLenghtRIB] = useState<RibLength>()
  const [lengthNUM, setLenghtNUM] = useState(0)
  const [lengthCodeIBAN, setLengthCodeIBAN] = useState<number>()
  const [listCarteBancaire, setListCarteBancaire] = useState<typeListebank[]>()
  const [codeIBAN, setCodeIBAN] = useState('')
  const [isBankListOpen, setIsBankListOpen] = useState(false)

  const COUNTRY_MAP: Record<string, string> = {
    '216': 'TUN',
    '221': 'SEN',
    '212': 'MAR',
    '92': 'PAK',
    '880': 'BDT',
    '90': 'TUR',
    '234': 'NGA',
    '254': 'KEN',
    '63': 'PHL',
  }

  useEffect(() => {
    const prefix = benefUpdate?.personalInfo.phone?.prefix
    if (prefix)
      if (prefix === '880') {
        setLenghtNUM(10)
      } else {
        const codeISO = COUNTRY_MAP[prefix]
        if (codeISO) {
          const data = LISTBANCAIRE[codeISO]

          setListCarteBancaire(data.banks)
          setLenghtRIB(data.LengthRIB)
          setLenghtCIN(data.LengthCIN)
          setLenghtNUM(data.lengthPhone)
          setLengthCodeIBAN(data.lengthCodeIBAN)
          setCodeIBAN(data.CodeIBAN)
        }
      }
  }, [benefUpdate])

  const [isDisabled, setIsDisabled] = useState(false)

  const [avatarId, setAvatarId] = useState(benefUpdate?.avatar)
  const [newImage, setNewImage] = useState(avatarId)
  const [heightScreen, setHeightScreen] = useState<number>(window.innerHeight)

  const prefix = benefUpdate?.personalInfo.phone.prefix

  const liste =
    prefix === '90'
      ? LISTBANCAIRE['TUR'].banks.map((item) => ({ value: item.name, code: item.code, swift: item.swift }))
      : prefix === '63'
        ? LISTBANCAIRE['PHL'].banks.map((item) => ({ value: item.name, code: item.code, swift: item.swift }))
        : []

  const optionsLien = [
    { index: 0, code: 'FAMILY', name: 'Famille' },
    { index: 1, code: 'FRIEND', name: 'Amis' },
    { index: 2, code: 'SELF', name: 'Moi même' },
    { index: 3, code: 'OTHER', name: 'Autres' },
  ]
  const listeLien = optionsLien.find((option) => option.code === benefUpdate?.relationship)

  // const disabled = listeLien?.name === 'Moi même' ? true : false
  const disabled = false
  const [updateImageBenef, setUpdateImageBenef] = useState(false)
  const [isConfirmListBanc, setIsConfirmListBanc] = useState<boolean>()

  const [banqueName, setBanqueName] = useState('')
  const [bankcode, setBankcode] = useState(benefUpdate?.bankCode || '')
  const [swiftBic, setSwiftBic] = useState('')
  const accountNumber = ''

  const handleSelectedBank = (item: { value: string; code: string; swift: string }) => {
    setIsConfirmListBanc(true)
    setBankcode(item.code)
    setSwiftBic(item.swift)
    setBanqueName(item.value)
    // setIsSelectedBank(true)
  }

  //   useEffect(() => {
  //     formik.setValues({
  //       nom: benefUpdate?.personalInfo.lastName || '',
  //       prenom: benefUpdate?.personalInfo.firstName|| '',
  //       numero: benefUpdate?.personalInfo.phone.number || '',
  //       bankCode: bankcode,
  //       bankName : banqueName || '',
  //       identifiantCardNumber: benefUpdate?.identifiantCardNumber || '',
  //       accountNumber: benefUpdate?.accountNumber || '',
  //       confirmerNumeroCompte: benefUpdate?.accountNumber || '',
  //       // avatar: benefUpdate?.avatar || '',
  //     })
  //     if(!benefUpdate?.avatar){
  //       if(benefUpdate?.personalInfo.gender=== 'female'){setAvatarId(26)}
  //       else if(benefUpdate?.personalInfo.gender=== 'male'){setAvatarId(25)}

  //     }else{ setAvatarId(benefUpdate?.avatar)}

  //     setIsDisabled(false)
  //     setBanqueName(!benefUpdate?.accountNumber  ? '' : (benefUpdate?.bankName? benefUpdate?.bankName : ''))

  //  }, [ isOpen, benefUpdate, bankcode, banqueName])

  console.log('tt', benefUpdate?.personalInfo.phone.number)

  const closeModalImageBenef = () => {
    setUpdateImageBenef(false)
    // setIsAvatarChanged(true)
  }
  const handleImageClick = (index: number) => {
    setNewImage(index)
  }
  const updateAvatar = () => {
    setAvatarId(newImage)
  }
  useEffect(() => {
    const fetchUpdateDatat = async () => {
      setNewImage(avatarId)
    }
    fetchUpdateDatat()
  }, [updateImageBenef])

  const validationSchema = yup.object({
    numero: yup
      .string()
      .required('Le numéro de téléphone est obligatoire.')
      .matches(new RegExp(`^\\d{${lengthNUM}}$`), `Le numéro doit contenir ${lengthNUM} chiffres.`),

    identifiantCardNumber: yup
      .string()
      .when(['confirmerNumeroCompte'], ([confirmerNumeroCompte], schema) => {
        const stringSchema = schema as yup.StringSchema
        if (confirmerNumeroCompte && prefix !== '216') {
          return stringSchema.required('Ce champ est requis')
        }
        return stringSchema
      })
      .when('prefix', ([prefix], schema) => {
        if (benefUpdate?.personalInfo.phone.prefix === '212') {
          return schema.matches(/^[A-Z 0-9]{5,10}$/, 'Format CIN Maroc invalide ')
        }

        return schema.matches(
          new RegExp(`^\\d{${lengthCIN}}$`),
          `Le numéro doit contenir exactement ${lengthCIN} chiffres`,
        )
      }),

    accountNumber: yup
      .string()
      .test('account-length', function (value) {
        const { path, createError } = this

        if (!value) return true

        // Philippines
        if (prefix === '63') {
          const min = 10
          const max = 16

          if (value.length < min || value.length > max) {
            return createError({
              path,
              message: `Le numéro de compte bancaire doit contenir entre ${min} et ${max} chiffres.`,
            })
          }

          return true
        }

        // Cas où LengthRIB est un objet { min, max }
        if (typeof lengthRIB === 'object' && lengthRIB !== null) {
          if (value.length < lengthRIB.min || value.length > lengthRIB.max) {
            return createError({
              path,
              message: `Le numéro de compte bancaire doit contenir entre ${lengthRIB.min} et ${lengthRIB.max} chiffres.`,
            })
          }

          return true
        }

        // Cas où LengthRIB est un nombre
        if (typeof lengthRIB === 'number') {
          if (value.length !== lengthRIB) {
            return createError({
              path,
              message: `${
                prefix === '90' ? "L'IBAN" : 'Le numéro de compte bancaire'
              } doit contenir exactement ${lengthRIB} chiffres.`,
            })
          }
        }

        return true
      })
      .matches(/^\d+$/, 'Le numéro de compte bancaire doit contenir uniquement des chiffres.'),

    confirmerNumeroCompte: yup
      .string()
      // .matches(new RegExp(`^\\d{${lengthRIB}}$`),`Le numéro de compte bancaire doit contenir exactement ${lengthRIB} chiffres.`)

      .oneOf(
        [yup.ref('accountNumber')],
        `Les numéros ${prefix === '90' || prefix === '63' ? 'IBAN' : 'RIB '} doivent correspondre.`,
      )

      .when('$', {
        is: true,
        then: (schema) => schema.required('Ce champ est requis'),
        otherwise: (schema) => schema.notRequired(),
      }),
  })

  const handleAccountChange = (accountNumber: string) => {
    if (prefix === '90' || prefix === '63') return setIsConfirmListBanc(true)

    const ibanPrefix = accountNumber.substring(0, lengthCodeIBAN)
    const matchingBank = listCarteBancaire?.find((bank) => bank.code === ibanPrefix)

    if (matchingBank) {
      setBankcode(matchingBank.code)
      setBanqueName(matchingBank.name)
      setSwiftBic(matchingBank.swift)
      setIsConfirmListBanc(true)
    } else {
      setIsConfirmListBanc(false)
    }
  }

  const HandleUpdateBeneficiary = async (value: {
    numero: string
    identifiantCardNumber: string
    accountNumber: string
  }) => {
    const token = user?.token?.accessToken
    // setIsDisabled(true)

    try {
      //   if(isConfirmListBanc)
      // {
      const response = await updateBeneficiary(
        benefUpdate?.personalInfo.gender,
        benefUpdate?.personalInfo.phone.prefix,
        value.numero || benefUpdate?.personalInfo.phone.number,
        benefUpdate?.relationship,
        'FR',
        avatarId,
        benefUpdate?.userId,
        benefUpdate?._id,
        benefUpdate?.personalInfo.firstName,
        benefUpdate?.personalInfo.lastName,
        banqueName,
        value.accountNumber,
        value.identifiantCardNumber,
        swiftBic,
        bankcode,
        token,
      )

      if (response.success) {
        toast.info(`Mise à jour effectuée`, {
          position: 'top-right',
          autoClose: 3000,
          icon: ({ theme, type }) => <span style={{ color: 'green' }}>✅</span>,
          style: {
            color: 'green',
            width: '350px',
          },
        })
        setTimeout(() => {
          setIsDisabled(true)
        })

        setBeneficiaryData((prevData) =>
          prevData
            ? prevData.map((item) =>
                item._id === benefUpdate?._id
                  ? {
                      ...item,
                      avatar: avatarId ?? 1,
                      personalInfo: {
                        ...item.personalInfo,
                        // firstName: value.prenom,
                        // lastName: value.nom,
                        phone: { ...item.personalInfo.phone, number: value.numero },
                      },
                    }
                  : item,
              )
            : [],
        )
      }

      closeModal()
      // }
    } catch (error) {
      console.log(error)
    }
  }

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      nom: benefUpdate?.personalInfo.lastName || '',
      prenom: benefUpdate?.personalInfo.firstName || '',
      numero: benefUpdate?.personalInfo?.phone.number || '',
      // bankCode: benefUpdate?.bankCode || '',
      // bankName : benefUpdate?.bankName || '',

      bankCode: prefix !== '90' && prefix !== '63' ? bankcode || '' : '',
      bankName: prefix !== '90' && prefix !== '63' ? banqueName || '' : '',

      identifiantCardNumber: benefUpdate?.identifiantCardNumber || '',
      accountNumber: benefUpdate?.accountNumber || '',
      confirmerNumeroCompte: benefUpdate?.accountNumber || '',

      // avatar : benefUpdate?.avatar || ''
    },
    validationSchema,
    onSubmit: HandleUpdateBeneficiary,
  })

  console.log('formik.values.numero:', formik.values)
  console.log('formik.initialValues.numero:', formik.initialValues)

  useEffect(() => {
    if (isOpen) {
      // formik.setTouched({}, false)
      formik.setTouched({})
    }
  }, [isOpen])

  useEffect(() => {
    const handleResize = () => setHeightScreen(window.innerHeight)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const hasFormikErrors = Object.keys(formik.errors).length !== 0

  const isTurkeyCase = prefix === '90' || prefix === '63'
  const isTunisieCase = prefix === '216'

  const hasAccountNumber = formik.values.accountNumber !== ''

  const hasCin = formik.values.identifiantCardNumber !== ''

  const hasBankName = banqueName !== ''

  // Si un des champs optionnels est rempli
  const hasStartedOptionalFields = hasAccountNumber || hasCin || (isTurkeyCase && hasBankName)

  // Tous les champs deviennent obligatoires
  const areOptionalFieldsIncomplete =
    hasStartedOptionalFields && (!hasAccountNumber || (!isTunisieCase && !hasCin) || (isTurkeyCase && !hasBankName))

  const hasBankChanged = banqueName !== benefUpdate?.bankName

  // Turquie : activation même si dirty=false
  const hasTurkeyBankModification = isTurkeyCase && hasStartedOptionalFields && hasBankChanged

  const isSubmitDisabled =
    hasFormikErrors ||
    areOptionalFieldsIncomplete ||
    (!formik.dirty && benefUpdate?.avatar === avatarId && !hasTurkeyBankModification)
  if (!isOpen) return null

  console.log('formikkk', formik, formik.errors)
  return (
    <div className="fixed inset-0 bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] flex items-center justify-center z-50  ">
      <div className={`relative bg-white rounded-2xl mx-auto shadow-inner  object-center w-[500px] sm:w-full  p-6`}>
        <img
          className="right-6 top-6 absolute hover:cursor-pointer "
          src={closeModalIcon}
          width={20}
          height={20}
          onClick={closeModal}
        />
        <div className="flex flex-col items-center justify-center">
          <Avatar
            ifUpdate={true}
            setUpdateImageUser={setUpdateImageBenef}
            genre={benefUpdate?.personalInfo.gender}
            avatar={avatarId}
          />

          <ImageUserUpdate
            isOpen={updateImageBenef}
            closeModal={closeModalImageBenef}
            selectedImageId={newImage}
            handleImageClick={handleImageClick}
            newImage={avatarId}
            setNewImage={setNewImage}
            updateAvatar={updateAvatar}
          />

          <form onSubmit={formik.handleSubmit} className=" flex flex-col items-center w-full">
            <div
              className={`${heightScreen < 660 ? 'h-[350px]' : 'h-[450px]'} pt-5 mb-[70px] flex flex-col  scrollbar-webkit gap-4 transition-transform overflow-y-auto  w-full px-2`}
            >
              <h3 className="h3">Informations Personnelles</h3>

              <div className="border rounded-[16px] p-3">
                <UpdateInfo
                  widthmsgError="w-[230px] sm:w-[150px]  lg:w-[210px]"
                  lengthValue={lengthCIN}
                  formik={formik}
                  styleValue2="items-end w-[50%]"
                  infoValue2={benefUpdate?.personalInfo.firstName}
                  title="Prénom"
                  isUpdate={false}
                  fieldName="prenom"
                />

                <UpdateInfo
                  widthmsgError="w-[230px] sm:w-[150px]  lg:w-[210px]"
                  lengthValue={lengthCIN}
                  formik={formik}
                  styleValue2="items-end w-[50%]"
                  infoValue2={benefUpdate?.personalInfo.lastName}
                  title="Nom"
                  isUpdate={false}
                  fieldName="nom"
                />

                <UpdateInfo
                  widthmsgError="w-[230px] sm:w-[150px]  lg:w-[210px]"
                  lengthValue={lengthCIN}
                  formik={formik}
                  styleValue2="items-end w-[50%]"
                  infoValue2={benefUpdate?.personalInfo.gender === 'female' ? 'Femme' : 'Homme'}
                  title="Genre"
                  isUpdate={false}
                  fieldName="nom"
                />

                <UpdateInfo
                  widthmsgError="w-[230px] sm:w-[150px]  lg:w-[210px]"
                  styleValue2="items-end"
                  disabled={disabled}
                  formik={formik}
                  infoValue1={prefix}
                  infoValue2={formik.values.numero}
                  title="Téléphone"
                  isUpdate={true}
                  fieldName="numero"
                  className="justify-between items-baseline gap-20 lg:gap-10 h-[70px]"
                  widthInput="w-[230px] sm:w-[150px]  h-[48px] lg:w-[210px] "
                />
                <UpdateInfo
                  widthmsgError="w-[230px] sm:w-[150px]  lg:w-[210px]"
                  lengthValue={lengthCIN}
                  formik={formik}
                  styleValue2="items-end w-[50%]"
                  infoValue2={listeLien?.name}
                  title="Lien"
                  isUpdate={false}
                  fieldName="nom"
                />
              </div>
              {prefix !== '880' && (
                <div className="w-full">
                  <h3 className="h3 mb-[10px]">Informations bancaires</h3>
                  <div className=" border  flex flex-col gap-2  items-center justify-center  rounded-[16px] px-3 w-full h-full ">
                    {prefix === '216' && (
                      <span className="text-[#422EAE] w-full flex text-start items-start justify-start text-[12px] sm:text-[10px]">
                        (Seuls les comptes en dinars tunisiens (TND) sont acceptés)
                      </span>
                    )}
                    {prefix !== '216' && (
                      <UpdateInfo
                        className="flex flex-col w-full items-start text-start justify-start gap-1 h-[80px]"
                        widthmsgError="w-[250px] sm:w-full "
                        styleValue2="flex flex-col w-full "
                        disabled={disabled}
                        lengthValue={lengthCIN}
                        formik={formik}
                        infoValue2={formik.values.identifiantCardNumber}
                        title="CIN du bénéficiaire"
                        isUpdate={true}
                        fieldName="identifiantCardNumber"
                        widthInput="w-full  "
                      />
                    )}
                    {(prefix === '90' || prefix === '63') && (
                      <div className="mb-2 w-full ">
                        <InputSelectComponent
                          liste={liste}
                          isOpen={isBankListOpen}
                          setIsOpen={setIsBankListOpen}
                          value={banqueName || ''}
                          setValue={setBanqueName}
                          placeholder="Sélectionnez votre banque"
                          label="Sélectionnez votre banque"
                          handleClick={handleSelectedBank}
                          messageIsEmpty="Aucunne banque ajouté pour le moment"
                          styleInput="h-[48px]"
                          styleLabel="text-[15px] sm:text-[13px] font-semibold text-[#6B7280]"
                        />
                      </div>
                    )}
                    <UpdateInfo
                      codeIban={codeIBAN}
                      className="flex flex-col w-full items-start text-start justify-start gap-1 h-[80px]"
                      widthmsgError="w-full "
                      styleValue2="flex flex-col w-full "
                      handleVerif={handleAccountChange}
                      // lengthValue={lengthRIB}
                      lengthValue={typeof lengthRIB === 'object' ? lengthRIB.max : lengthRIB}
                      disabled={disabled}
                      formik={formik}
                      infoValue2={formik.values.accountNumber}
                      title={prefix === '90' || prefix === '63' ? 'Numéro IBAN' : 'Numéro de compte bancaire'}
                      isUpdate={true}
                      fieldName="accountNumber"
                      widthInput="w-full  "
                    />
                    <UpdateInfo
                      codeIban={codeIBAN}
                      className="flex flex-col w-full items-start text-start justify-start gap-1 h-[80px]"
                      widthmsgError="w-full "
                      styleValue2="flex flex-col w-full "
                      disabled={disabled}
                      formik={formik}
                      // lengthValue={lengthRIB}
                      lengthValue={typeof lengthRIB === 'object' ? lengthRIB.max : lengthRIB}
                      infoValue2={formik.values.confirmerNumeroCompte}
                      title={prefix === '90' || prefix === '63' ? 'Confirmez le numéro IBAN' : 'Confirmation du RIB'}
                      isUpdate={true}
                      fieldName="confirmerNumeroCompte"
                      widthInput="w-full  "
                    />
                  </div>
                </div>
              )}
            </div>

            <div className=" absolute w-full flex bottom-0 mx-auto bg-[#FFF] h-[80px]">
              <button
                type="submit"
                disabled={
                  isSubmitDisabled
                  // (Object.keys(formik.errors).length!==0 || formik.dirty=== false)
                  // &&  benefUpdate?.avatar===avatarId
                }
                className={classNames(
                  ' text-white  mx-auto rounded-lg w-[340px] font-bold h-[56px] lg:h-[46px] lg:w-full lg:mx-[50px]',
                  isSubmitDisabled
                    ? // (Object.keys(formik.errors).length!==0 || formik.dirty=== false) &&  benefUpdate?.avatar===avatarId
                      ' bg-[#D1D1FF]  cursor-not-allowed'
                    : 'bg-[#5754E5] hover:bg-[#4D36CC]',
                )}
              >
                {isDisabled || formik.isSubmitting ? (
                  <svg
                    className="w-6 h-6 mx-auto animate-spin text-white "
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-50"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
                    ></path>
                  </svg>
                ) : (
                  ''
                )}
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* </div> */}
    </div>
  )
}

export default UpdateModalBeneficiary
